import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  resend() {
    const url = apiRoutes.authResendEmailComfirmationPath();

    return FetchHelpers.post(url);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/auth/EmailConfirmationRepository.js